const priceFormat = (price, currency = 'USD', defaultText = '') =>
  price ? (String(currency).toUpperCase() === 'USD' ? `$${price}` : `${price} ${currency}`) : defaultText;

export default priceFormat;



// WEBPACK FOOTER //
// ./src/lib/price-format.js